// src/components/dashboard/NewVsOldClientsChart.tsx
import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import api from '../../services/api';
import { ChartContainer, ChartTitle, ChartWrapper } from './dashboard.styled';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const months = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

interface ClientData {
    month: string; // formato: 2025-01
    novos: number;
    antigos: number;
}

const NewVsOldClientsChart: React.FC = () => {
    const [data, setData] = useState<ClientData[]>([]);

    useEffect(() => {
        api.get('/dashboard/clients-new-vs-old').then((res) => {
            setData(res.data);
        });
    }, []);

    const currentYear = new Date().getFullYear();

    const chartData = {
        labels: months,
        datasets: [
            {
                label: 'Clientes Novos',
                data: months.map((_, i) => {
                    const key = `${currentYear}-${String(i + 1).padStart(2, '0')}`;
                    return data.find((d) => d.month === key)?.novos || 0;
                }),
                backgroundColor: '#ec407a',
                stack: 'clientes',
            },
            {
                label: 'Clientes Antigos',
                data: months.map((_, i) => {
                    const key = `${currentYear}-${String(i + 1).padStart(2, '0')}`;
                    return data.find((d) => d.month === key)?.antigos || 0;
                }),
                backgroundColor: '#42a5f5',
                stack: 'clientes',
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { position: 'top' as const },
            title: { display: false },
        },
        scales: {
            x: { stacked: true },
            y: { stacked: true, beginAtZero: true },
        },
    };

    return (
        <ChartContainer>
            <ChartTitle>Novos vs Antigos Clientes ({currentYear})</ChartTitle>
            <Bar options={options} data={chartData} height={50} />
        </ChartContainer>
    );



};

export default NewVsOldClientsChart;
